export default __webpack_public_path__ + "static/binance-c2364ac77f66dd1802cbf147719fab86.svg";